export function clearBookingStorage() {
    const keys = [
        'bookedData',
        'backendBookingData',
        'bookingId',
        'bookingData1',
        'userData1',
        'paymentType',
        'tripImage',
        'packId',
        'packDateId',
        'paymentComplete'
    ];

    keys.forEach((key) => localStorage.removeItem(key));
}
